// extracted by mini-css-extract-plugin
module.exports = {"more-action-wrapper":"MoreDdlActions-module__more-action-wrapper__2XdRQ","button-like-dropdown":"MoreDdlActions-module__button-like-dropdown__1XLFX"};